import moment from 'moment';

export const DAY_ORDER = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

export const dayOfWeekMap = {
  mon: 'Mon',
  tue: 'Tue',
  wed: 'Wed',
  thu: 'Thu',
  fri: 'Fri',
  sat: 'Sat',
  sun: 'Sun',
};

export const normalizeDayKey = dayOfWeek => (dayOfWeek || '').toLowerCase().trim();

export const formatTime = time => moment(time, 'HH:mm').format('h:mm A');

export const timeKey = (startTime, endTime) => `${startTime}-${endTime}`;

export const formatDayLabel = dayKey => dayOfWeekMap[normalizeDayKey(dayKey)] || dayKey;

export const formatDayRangeLabel = (startDay, endDay) => {
  const startLabel = formatDayLabel(startDay);
  const endLabel = formatDayLabel(endDay);

  if (normalizeDayKey(startDay) === normalizeDayKey(endDay)) {
    return `${startLabel}:`;
  }
  return `${startLabel} - ${endLabel}:`;
};

export const isSameTimeAllWeek = (entries = []) =>
  entries.length === 7 &&
  entries.every(e => e.startTime === entries[0].startTime && e.endTime === entries[0].endTime);

/**
 * Groups availability entries into contiguous day ranges when they share the same time.
 * Returns: [{ startDay, endDay, startTime, endTime }]
 */
export const groupOpeningHours = (entries = []) => {
  if (!Array.isArray(entries) || entries.length === 0) return [];

  const normalized = entries.map(e => {
    const dayKey = normalizeDayKey(e.dayOfWeek);
    return {
      ...e,
      _dayKey: dayKey || e.dayOfWeek,
      _orderIndex: DAY_ORDER.indexOf(dayKey),
      _timeKey: timeKey(e.startTime, e.endTime),
    };
  });

  const known = normalized
    .filter(e => e._orderIndex !== -1)
    .sort((a, b) => a._orderIndex - b._orderIndex);

  const unknown = normalized.filter(e => e._orderIndex === -1);

  const all = [...known, ...unknown];

  const groups = [];
  let current = null;

  for (let i = 0; i < all.length; i++) {
    const entry = all[i];

    if (!current) {
      current = {
        startDay: entry._dayKey,
        endDay: entry._dayKey,
        startTime: entry.startTime,
        endTime: entry.endTime,
        _lastOrderIndex: entry._orderIndex,
        _timeKey: entry._timeKey,
        _isKnownDay: entry._orderIndex !== -1,
      };
      continue;
    }

    const isSameTime = current._timeKey === entry._timeKey;

    const isContiguousKnownDays =
      current._isKnownDay &&
      entry._orderIndex !== -1 &&
      typeof current._lastOrderIndex === 'number' &&
      entry._orderIndex === current._lastOrderIndex + 1;

    if (isSameTime && isContiguousKnownDays) {
      current.endDay = entry._dayKey;
      current._lastOrderIndex = entry._orderIndex;
    } else {
      groups.push(current);
      current = {
        startDay: entry._dayKey,
        endDay: entry._dayKey,
        startTime: entry.startTime,
        endTime: entry.endTime,
        _lastOrderIndex: entry._orderIndex,
        _timeKey: entry._timeKey,
        _isKnownDay: entry._orderIndex !== -1,
      };
    }
  }

  if (current) groups.push(current);

  return groups.map(g => ({
    startDay: g.startDay,
    endDay: g.endDay,
    startTime: g.startTime,
    endTime: g.endTime,
  }));
};
